import {
  EDIT_PROFILE__ADD_ADDRESS,
  ADD_ARTICLE,
  ADD_CUSTOMERS,
  SELECT_CUSTOMER,
  UPDATE_CUSTOMER,
  ADD_DRIVERS,
  ADD_NEW_ADDRESS,
  ADD_NEW_CUSTOMER,
  REMOVE_CUSTOMER_ADDRESS,
  ADD_NEW_ORDER,
  SELECT_ORDER,
  ADD_NEW_SERVICES,
  ADD_NEW_SERVICE,
  REMOVE_SERVICE,
  ADD_NEW_DRIVERS,
  ADD_NEW_DRIVER,
  REMOVE_DRIVER,
  SELECT_DRIVER,
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  API_SEND_SMS_REQUEST,
  API_SEND_SMS_FAILURE,
  API_SEND_SMS_SUCCESS,
  UPDATE_DRIVER,
  DATA_BASE_EXPORT,
  IMPORT_NEW_CUSTOMERS,
  IMPORT_NEW_SERVICES,
  IMPORT_NEW_DRIVERS,
  EXPORT_DATA_FILE,
  IMPORT_DATA_FILE,
  REMOVE__DATA,
  SEND_DRIVER_SMS,
  SEND_CUSTOMER_SMS,
} from "../constants/actions-types";

export const addArticle = (article) => ({
  type: ADD_ARTICLE,
  payload: { article },
});

export const addCustomers = (customers) => ({
  type: ADD_CUSTOMERS,
  customers: customers,
});

export const selectCustomer = (customer) => ({
  type: SELECT_CUSTOMER,
  selectCustomer: customer,
});

export const addNewCustomer = (customer) => ({
  type: ADD_NEW_CUSTOMER,
  customer: customer,
});

export const selectOrder = (order) => ({ type: SELECT_ORDER, order: order });

export const addServices = (services) => ({
  type: ADD_NEW_SERVICES,
  services: services,
});

export const addNewService = (service) => ({
  type: ADD_NEW_SERVICE,
  service: service,
});

export const removeService = (service) => ({
  type: REMOVE_SERVICE,
  service: service,
});

export const addDrivers = (drivers) => ({
  type: ADD_NEW_DRIVERS,
  drivers: drivers,
});

export const addNewDriver = (driver) => ({
  type: ADD_NEW_DRIVER,
  driver: driver,
});

export const removeDriver = (driver) => ({
  type: REMOVE_DRIVER,
  driver: driver,
});

export const selectDriver = (driver) => ({
  type: SELECT_DRIVER,
  driver: driver,
});

export const apiCallRequest = () => ({ type: API_CALL_REQUEST });

export const apiCallFailure = (error) => ({
  type: API_CALL_FAILURE,
  error: error,
});

export const apiCallSuccess = (response) => ({
  type: API_CALL_SUCCESS,
  response: response,
});

export const removeCustomers = () => ({ type: REMOVE__DATA });

export const changeIsProfile = (isProfile) => ({
  type: EDIT_PROFILE__ADD_ADDRESS,
  isEditProfile: isProfile,
});

export const addNewOrder = (customer, order) => ({
  type: ADD_NEW_ORDER,
  order: order,
  selected: customer,
});

export const updateCustomer = (selected, customer) => ({
  type: UPDATE_CUSTOMER,
  selectCustomer: customer,
  selected: selected,
});

export const updateDriver = (driver, update) => ({
  type: UPDATE_DRIVER,
  driver: driver,
  update: update,
});

export const addNewAddress = (customer, address) => ({
  type: ADD_NEW_ADDRESS,
  selected: customer,
  address: address,
});

export const removeCustomerAddress = (customer, address) => ({
  type: REMOVE_CUSTOMER_ADDRESS,
  selected: customer,
  address: address,
});

export const apiSendSMSRequest = (payload) => ({
  type: API_SEND_SMS_REQUEST,
  payload,
});

export const apiSendSMSFailure = (error) => ({
  type: API_SEND_SMS_FAILURE,
  error: error,
});

export const apiSendSMSSuccess = (response) => ({
  type: API_SEND_SMS_SUCCESS,
  response: response,
});

//data importer actions

export const importCustomers = (customers) => ({
  type: IMPORT_NEW_CUSTOMERS,
  customers: customers,
});

export const importDrivers = (drivers) => ({
  type: IMPORT_NEW_DRIVERS,
  drivers: drivers,
});

export const importServices = (services) => ({
  type: IMPORT_NEW_SERVICES,
  services: services,
});

export const exportDatafile = () => ({
  type: EXPORT_DATA_FILE,
});

export const importDatafile = (file) => ({
  type: IMPORT_DATA_FILE,
  file: file,
});

//send sms methods
export const sendDriverSMS = (payload) => ({
  type: SEND_DRIVER_SMS,
  payload: payload,
});

export const sendCustomerSMS = (payload) => ({
  type: SEND_CUSTOMER_SMS,
  payload: payload,
});
